import Page from 'components/Page';
import React from 'react';
import {Button, ButtonGroup, Card, CardBody, Col, FormGroup, Input, Label, Row, Table,} from 'reactstrap';
import CardBlock from 'reactstrap/es/CardBlock';
import BasePage from './BasePage';
import Global, {DD_MM_YYYY_HH_MM_SS} from '../utils/Global';
import {isEmpty, parseDate} from '../utils/Utilities';
import {MdDelete, MdEdit} from 'react-icons/md';
import ConfirmDialog from '../components/modal/ConfirmDialog';
import ActiveOption from '../components/Widget/ActiveOption';
import ItemOption from '../components/Widget/ItemOption';
import Pagination from '../components/Pagination';
import queryString from 'query-string';
import ActiveLabel from '../components/Widget/ActiveLabel';
// import label from '../message/Label'
import label from 'enqc-utilities/src/label/Label'
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";
import DropdownInput from "../components/form/DropdownInput";


const tableTypes = ['', 'bordered', 'striped', 'hover'];


class DistrictPage extends BasePage{
  constructor(props) {
    super(props);
    this.state = {
      districts : [],
      district:{},
      provinces : [],
      province:{},
      cities : [],
      city:{},
      modalAddConfirm:false,
      modalDeleteConfirm:false,
      modal: false,
      ascending:true,
      sortir:'name',
      page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
      totalPage:0,
      totalElement:0,
      pageElement:0,
    }
  }

  componentWillReceiveProps(props, nextContext) {
    if(props!=this.props){
      this.setState({
        page:queryString.parse(props.query).page?queryString.parse(props.query).page:1
      }, () => {
        this.fetchAll()
      })
    }
  }


  componentDidMount() {
    super.componentDidMount();
    this.fetchAll()
    this.fetchProvinces()
  }

  confirmSave = () =>{
    let {district, city, province} = this.state
    if(isEmpty(district.name) || isEmpty(city) || isEmpty(province)){
      this.showDialog(label.Warning, label.PleaseCompleteTheFields)
    }else{
      this.setState({
        modalAddConfirm:true
      })
    }
  }

  save = () => {
    let {district, city, province} = this.state
    if(!district.id && !district.active){
      district.active = false ;
    }
    district.city = city

    this.setState({
      modalAddConfirm:false
    }, () => {
      this.post(Global.API.DISTRICT_SAVE, district, null, res => {
        if(res.code===200){
          this.setState({
            district:{}
          }, () => {
            this.fetchAll()
          })
        }
      }, true, true);
    })
  }

  confirmDelete = () =>{
    this.setState({
      modalDeleteConfirm:true
    })
  }

  delete = () => {
    this.setState({
      modalDeleteConfirm:false
    }, () => {
      this.get(Global.API.DISTRICT_DELETE+"/"+this.state.district.id, null, null, res => {
        if(res.code===200){
          this.setState({
            district:{}
          }, () => {
            this.fetchAll()
          })
        }
      },true, true);
    })
  }

  closeDialog = () =>{
    this.setState({
      modalAddConfirm:false,
      modalDeleteConfirm:false
    })
  }

  fetchAll = () => {
    this.get(Global.API.DISTRICTS, {
      params:{
        cityId:this.state.city.id,
        ascending:this.state.ascending,
        sortir:this.state.sortir,
        page:this.state.page-1,
      }
    }, null, response=>{
      if(response.code === 200){
        this.setState({
          districts : response.data,
          totalPage: response.totalPage,
          totalElement: response.totalElement,
          pageElement: response.pageElement,
        })
      }
    }, true, true);
  }

  refresh = (ascending, sortir) => (
      this.setState({
        ascending:ascending,
        sortir:sortir
      }, () => {
        this.fetchAll()
      })
  )

  fetchProvinces = () => {
    this.get(Global.API.PROVINCES, {
      params:{
        ascending:true,
        sortir:'name'
      }
    }, null, response=>{
      if(response.code === 200){
        this.setState({
          provinces : response.data
        })
      }
    }, true, true);
  }

  fetchCities = () => {
    if(this.state.province.id){
      this.get(Global.API.CITIES, {
        params:{
          provinceId:this.state.province.id,
          ascending:this.state.ascending,
          sortir:this.state.sortir
        }
      }, null, response=>{
        if(response.code === 200){
          this.setState({
            cities : response.data
          })
        }
      }, true, true);
    }else{
      this.setState({cities : []})
    }
  }



  render() {
    let provinces = this.state.provinces
    let province = this.state.province
    let cities = this.state.cities
    let city = this.state.city
    let {ascending, sortir} = this.state
    let orderOptions = delegateObjectsForSelection(
        {name:label.Name, field:'name'},
        {name:label.Created, field:'created'},
        {name:label.Updated, field:'updated'}
    )
    let ascendingOptions = delegateObjectsForSelection( {name:label.Ascending, field:true},{name:label.Descending, field:false})
    return (
        <Page
            title={label.District}
            breadcrumbs={[{ name: label.District, active: true }]}
            className="TablePage">
          {super.render()}
          <ConfirmDialog
              showing={this.state.modalAddConfirm}
              title={label.UpdateConfirmation}
              message={label.UpdateConfirmationMessage}
              okCallback={this.save}
              cancelCallback={this.closeDialog}/>
          <ConfirmDialog
              showing={this.state.modalDeleteConfirm}
              title={label.DeleteConfirmationTitle}
              message={label.DeleteConfirmationMessage}
              okCallback={this.delete}
              cancelCallback={this.closeDialog}/>
          <Row key={1}>
            <Col>
              <Card>
                <PrimaryCardHeader content={label.District}/>
                <CardBody>
                  <Row>
                    <Col md={3}>
                      <Card>
                        <PrimaryCardHeader content={label.BasicInformation}/>
                        <CardBody>
                          <Row>
                            <CardBlock>
                              <FormGroup>
                                <Label for="name">{label.Name}</Label>
                                <Input
                                    type="text"
                                    name="name"
                                    value={!isEmpty(this.state.district.name)?this.state.district.name:""}
                                    onChange={(e) =>{
                                      let ctg = this.state.district
                                      if(ctg!=null){
                                        ctg.name = e.target.value
                                        this.setState({
                                          district:ctg
                                        })
                                      }
                                    }}
                                    placeholder={label.EnterDistrictName}
                                />
                              </FormGroup>
                              <FormGroup>
                                <ItemOption
                                    title={label.SelectProvince}
                                    objects={provinces}
                                    default={province!=null?province.id:null}
                                    noTranslation={true}
                                    callback={(province)=>{
                                      if(province!=null){
                                        this.setState({
                                          province:province
                                        }, () => {
                                          this.fetchCities()
                                        })
                                      }else{
                                        this.setState({
                                          province:{}
                                        }, () => {
                                          this.fetchCities()
                                        })
                                      }
                                    }}
                                />
                              </FormGroup>
                              <FormGroup>
                                <ItemOption
                                    title={label.SelectCity}
                                    objects={cities}
                                    default={city!=null?city.id:null}
                                    noTranslation={true}
                                    callback={(city)=>{
                                      if(city!=null){
                                        this.setState({
                                          city:city
                                        }, () => {
                                          this.fetchAll()
                                        })
                                      }else{
                                        this.setState({
                                          city:{}
                                        }, () => {
                                          this.fetchAll()
                                        })
                                      }
                                    }}
                                />
                              </FormGroup>
                              <FormGroup>
                                <ActiveOption
                                    default={this.state.district.active}
                                    callback={(active)=>{
                                      let ctg = this.state.district
                                      if(ctg!=null){
                                        ctg.active = active
                                        this.setState({
                                          district:ctg
                                        })
                                      }

                                    }}
                                />
                              </FormGroup>
                            </CardBlock>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonGroup className="float-left">
                                <Button color="danger" onClick={e => (
                                    this.setState({
                                      district:null
                                    })
                                )}>{label.Cancel}</Button>
                              </ButtonGroup>
                            </Col>
                            <Col>
                              <ButtonGroup className="float-right">
                                <Button color="primary" onClick={e=>(
                                    this.confirmSave()
                                )}> {
                                  (this.state.district!=null && this.state.district.id!=null)?label.Update:label.Add
                                } </Button>

                              </ButtonGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={9}>
                      <Card body>
                        <Row>
                          <Col>
                            <FormGroup>
                              <ItemOption
                                  title={label.SelectProvince}
                                  objects={this.state.provinces}
                                  default={this.state.province!=null?this.state.province.id:null}
                                  noTranslation={true}
                                  callback={(province)=>{
                                    let district = this.state.district
                                    if(province!=null && district!=null){
                                      district.province = province
                                      this.setState({
                                        district:district,
                                        province:province
                                      }, () => {
                                        this.fetchCities()
                                      })
                                    }else{
                                      district.province = {}
                                      this.setState({
                                        district:district,
                                        province:{}
                                      }, () => {
                                        this.fetchCities()
                                      })
                                    }
                                  }}
                              />
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <ItemOption
                                  title={label.SelectCity}
                                  objects={cities}
                                  default={city!=null?city.id:null}
                                  noTranslation={true}
                                  callback={(city)=>{
                                    if(city!=null){
                                      this.setState({
                                        city:city
                                      }, () => {
                                        this.fetchAll()
                                      })
                                    }else{
                                      this.setState({
                                        city:{}
                                      }, () => {
                                        this.fetchAll()
                                      })
                                    }
                                  }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <ButtonGroup className="d-flex w-100">
                              <DropdownInput
                                  title={label.SortBy}
                                  options={orderOptions}
                                  onSelect={(item) => {
                                    this.refresh(ascending, item.field, true)
                                  }}
                                  onReset={() => {
                                    this.refresh(ascending, "created", true)
                                  }}/>
                              &nbsp;&nbsp;&nbsp;
                              <DropdownInput
                                  options={ascendingOptions}
                                  onSelect={(item) => {
                                    this.refresh(item.field, sortir, true)
                                  }}
                                  onReset={() => {
                                    this.refresh(true, sortir, true)
                                  }}/>
                            </ButtonGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Table responsive hover>
                              <thead>
                              <tr>
                                <th>#</th>
                                <th>{label.Name}</th>
                                <th>{label.Province}</th>
                                <th>{label.City}</th>
                                <th>{label.Status}</th>
                                <th>{label.Updated}</th>
                                <th>{label.Edit}</th>
                              </tr>
                              </thead>
                              <tbody>
                              {
                                this.state.districts.map((item, index) =>(
                                    <tr key={index}>
                                      <th scope="row">{((this.state.page-1)* this.state.pageElement)+(++index)}</th>
                                      <td>{item.name}</td>
                                      <td>{item.city.province.name}</td>
                                      <td>{item.city.name}</td>
                                      <td><ActiveLabel active={item.active}/></td>
                                      <td>{parseDate(item.updated, DD_MM_YYYY_HH_MM_SS)}</td>
                                      <td>
                                        <Button color="danger" onClick={e => {
                                          this.setState({
                                            district:item
                                          }, () => {
                                            this.confirmDelete()
                                          })
                                        }}>
                                          <MdDelete/>
                                        </Button>
                                        &nbsp;
                                        <Button color="primary" onClick={e=>(
                                            this.setState({
                                              district:item
                                            })
                                        )}>
                                          <MdEdit/>
                                        </Button>
                                      </td>
                                    </tr>
                                ))
                              }
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
                <Pagination {...this.props} currentPage={parseInt(this.state.page)} pageCount={this.state.totalPage} />
              </Card>
            </Col>
          </Row>
        </Page>
    );
  }
}


export default Object.assign(DistrictPage, {ENDPOINT : "/districts"})
